import React from 'react'
import {StudentInput} from '../StudentInput/StudentInput'
import './new-student-modal.css'


const NewStudentModal = (props) => {

    React.useEffect(() => {
        openingAnimation()
    }, [])

    React.useEffect(() => {
        if(props.newFamily.school !== '') {
            document.getElementById('create-student-info').style.backgroundColor = 'green'
            document.getElementById('create-student-info').style.cursor = 'pointer'
        } else {
            document.getElementById('create-student-info').style.backgroundColor = 'rgb(182, 182, 182)'
            document.getElementById('create-student-info').style.cursor = 'default'
        }
    }, [props.newFamily.school])

    const checkForRealEmail = (email) => {
        if(email.includes('@') && email.includes('.')) {
            document.getElementById("new-email").style.border = "1px solid #000"
        } else {
            document.getElementById("new-email").style.border = "1px solid red"
        }
        props.editStudentInfo(props.index, `primaryEmail`, email, "")
    }

    const openingAnimation = () => {
        document.getElementById('student-modal-content').style.opacity = 1
        document.getElementById('student-modal-content').style.transform = 'scale(1)'
    }
    const closingAnimation = () => {
        document.getElementById('student-modal-content').style.opacity = 0
        document.getElementById('student-modal-content').style.transform = 'scale(0.5)'
    }

    const tryToMakeNewFamily = () => {
        if(props.newFamily.school !== 'ALL' && document.getElementById('new-email').value.includes('@') && document.getElementById('new-email').value.includes('.')) {
            props.addANewFamily()
        } else {
            alert('Please fill out all required fields!')
        }
    }

    const cancelOut = (tar) => {
        if(tar === "student-modal-wrapper" || tar === "student-modal-the-x" ) {
            closingAnimation()
            setTimeout(() => {
                props.setNewStudent(false)
            }, 200)
        }
    }

    return (
        <div className="student-modal-wrapper" id="student-modal-wrapper" onClick={(e) => cancelOut(e.target.id)}>
            <div className="student-modal-content" id="student-modal-content">
                <div className="student-modal-x-wrapper">
                    <div id="student-modal-the-x" onClick={(e) => cancelOut(e.target.id)} className="student-modal-the-x">x</div>
                </div>
                <div className="student-modal-header">
                    <div className="student-modal-header-left">
                        <div className="student-modal-title">Add a New Family</div>
                        <div className="student-modal-subtitle">Family Information</div>
                    </div>
                    <div className="student-modal-header-right">
                        <div className="family-status-wrapper">
                            <select id="family-status" className="student-modal-firstname" value={props.newFamily.familyStatus} onChange={(e) => props.editStudentInfo(props.index, `familyStatus`, e.target.value, "")} >
                            <option value="---" default>Status</option>
                                <option value="Active" default>Active</option>
                                <option value="Being Onboarded">Being Onboarded</option>
                                {/* <option value="Prospective">Prospective</option> */}
                                <option value="Waitlist">Waitlist</option>
                                <option value="Taking a Break">Taking a Break</option>
                                <option value="Summer Break">Summer Break</option>
                                <option value="Scholarship">Scholarship</option>
                                <option value="Needs New Teacher">Needs New Teacher</option>
                                <option value="Left the School">Left the School</option>
                                <option value="Inquired">Inquired</option>
                            </select>
                        </div>
                    </div>
                    <div className="family-school-wrapper">
                        <select id="new-school" className="family-status new-family-status" value={props.newFamily.school} onChange={(e) => props.editStudentInfo(props.index, `school`, e.target.value, "")} >
                            <option value="" default>Select a school</option>
                            <option value="MMA">Mountainside</option>
                            <option value="LSMA">Lakeside</option>
                            <option value="TMA">Treeside</option>
                            <option value="GLMA">Greatlakes</option>
                            <option value="MOR">Morningside</option>
                            <option value="PSMA">Parkside</option>
                        </select>
                    </div>
                </div>
                <div className="first-name-wrapper top-first-name-wrapper">
                    <div className="input-label">Family</div>
                    <input id="new-family" className="student-modal-firstname" placeholder="Family Name" value={props.newFamily.familyName} onChange={(e) => props.editStudentInfo(props.index, `familyName`, e.target.value, "")}/>
                </div>
                <div className="right-side-name-wrapper">
                    <div className="input-label">Parent/Guardian Name(s)</div>
                    <input id="new-parents" className="student-modal-firstname" placeholder="Parent" value={props.newFamily.primaryParentName} onChange={(e) => props.editStudentInfo(props.index, `primaryParentName`, e.target.value, "")}/>
                </div>
                <div className="first-name-wrapper">
                    <div className="input-label">Email</div>
                    <input onChange={(e) => checkForRealEmail(e.target.value)} value={props.newFamily.primaryEmail} id="new-email" className="student-modal-firstname it-required" placeholder="Email"/>
                </div>
                <div className="first-name-wrapper phone-numbers-wrapper">
                    <div className="input-label student-modal-half-width-label">Cell #</div>
                    <div className="input-label student-modal-half-width-label">Home #</div>
                    <input id="new-cellNumber" className="student-modal-firstname student-modal-half-width" placeholder="Cell #" value={props.newFamily.primaryCellphone} onChange={(e) => props.editStudentInfo(props.index, `primaryCellphone`, e.target.value, "")}/>
                    <input id="new-homeNumber" className="student-modal-firstname student-modal-half-width" placeholder="Home #"  value={props.newFamily.primaryHomePhone} onChange={(e) => props.editStudentInfo(props.index, `primaryHomePhone`, e.target.value, "")}/>
                </div>
                <div className="right-side-address-wrapper">
                    <div className="right-side-address">
                        <div className="input-label">Street Address</div>
                        <input id="new-street-address" className="student-modal-address" placeholder="Street Address" value={props.newFamily.address.addressLine1} onChange={(e) => props.editStudentInfo(props.index, `addressLine1`, e.target.value, "")}/>
                    </div>
                    <div className="triple-address-wrapper">
                        <div className="student-modal-right-side-city">
                            <div className="input-label address-label-third">City</div>
                            <input id="new-city" className="student-modal-address address-input-third" placeholder="City" value={props.newFamily.address.city} onChange={(e) => props.editStudentInfo(props.index, `city`, e.target.value, "")}/>
                        </div>
                        <div className="student-modal-right-side-city">
                            <div className="input-label address-label-third">State</div>
                            <input id="new-state" className="student-modal-address address-input-third" placeholder="State" value={props.newFamily.address.state} onChange={(e) => props.editStudentInfo(props.index, `state`, e.target.value, "")}/>
                        </div>
                        <div className="student-modal-right-side-city">
                            <div className="input-label address-label-third">Zip</div>
                            <input id="new-zip" className="student-modal-address address-input-third" placeholder="Zip" value={props.newFamily.address.zipcode} onChange={(e) => props.editStudentInfo(props.index, `zipcode`, e.target.value, "")}/>
                        </div>
                    </div>
                </div>
                <div className="right-side-notes">
                    <div className="input-label">Notes</div>
                    <textarea id="new-notes" className="student-modal-notes" placeholder="Any Notes?" value={props.newFamily.familyNotes} onChange={(e) => props.editStudentInfo(props.index, `familyNotes`, e.target.value, "")} />
                </div>
                <div className="student-modal-line"></div>
                {props.newFamily.students.map((student, index) => (
                    <StudentInput 
                        key={student.studentId} 
                        addAStudentToATeacher={props.addAStudentToATeacher} 
                        removeAStudentFromATeacher={props.removeAStudentFromATeacher} 
                        theSchool={props.newFamily.school} teachers={props.teachers} 
                        FamilyId={props.newFamily.id} student={student} 
                        removeAStudent={props.removeAStudent} 
                        index={index} 
                        editStudentInfo={props.editStudentInfo}  
                    />
                ))}
                    <div className="add-a-student-btn" onClick={() => props.addAnotherNewStudent()}>+ Add a student</div>
                    {props.newFamily.school === '' && <h5 className="no-school-warning">Please select at school</h5>}
                <div id="create-student-info" onClick={() => tryToMakeNewFamily()} className="new-student-save">Add Family</div>
            </div>
        </div>
    )
}

export default NewStudentModal;